/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamRevisionLangBotexamlangidTranslationQueryResponse,
  GetApiV1ExamRevisionLangBotexamlangidTranslationPathParams,
  GetApiV1ExamRevisionLangBotexamlangidTranslationQueryParams,
  GetApiV1ExamRevisionLangBotexamlangidTranslation401,
  GetApiV1ExamRevisionLangBotexamlangidTranslation404,
  GetApiV1ExamRevisionLangBotexamlangidTranslation500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionLangBotexamlangidTranslation.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamRevisionLangBotexamlangidTranslation } from "../../clients/examRevisionController/getApiV1ExamRevisionLangBotexamlangidTranslation.ts";

export const getApiV1ExamRevisionLangBotexamlangidTranslationQueryKey = (
  botExamLangId: GetApiV1ExamRevisionLangBotexamlangidTranslationPathParams["botExamLangId"],
  params?: GetApiV1ExamRevisionLangBotexamlangidTranslationQueryParams,
) =>
  [
    {
      url: "/api/v1/exam/revision/lang/:botExamLangId/translation",
      params: { botExamLangId: botExamLangId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamRevisionLangBotexamlangidTranslationQueryKey =
  ReturnType<typeof getApiV1ExamRevisionLangBotexamlangidTranslationQueryKey>;

export function getApiV1ExamRevisionLangBotexamlangidTranslationQueryOptions(
  botExamLangId: GetApiV1ExamRevisionLangBotexamlangidTranslationPathParams["botExamLangId"],
  params?: GetApiV1ExamRevisionLangBotexamlangidTranslationQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamRevisionLangBotexamlangidTranslationQueryKey(
    botExamLangId,
    params,
  );
  return queryOptions<
    GetApiV1ExamRevisionLangBotexamlangidTranslationQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionLangBotexamlangidTranslation401
      | GetApiV1ExamRevisionLangBotexamlangidTranslation404
      | GetApiV1ExamRevisionLangBotexamlangidTranslation500
    >,
    GetApiV1ExamRevisionLangBotexamlangidTranslationQueryResponse,
    typeof queryKey
  >({
    enabled: !!botExamLangId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamRevisionLangBotexamlangidTranslation(
        botExamLangId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna os dados do editor de tradução para um idioma alvo, paginados por questão. Exibe lado a lado o texto original em pt-BR e o texto traduzido. Cada página contém uma questão com suas opções. Retorna 404 se o idioma ou a versão pt-BR não forem encontrados. **(Requer Authorization para autenticação)**
 * @summary Carregar editor de tradução de idioma da prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang/:botExamLangId/translation}
 */
export function useGetApiV1ExamRevisionLangBotexamlangidTranslation<
  TData = GetApiV1ExamRevisionLangBotexamlangidTranslationQueryResponse,
  TQueryData = GetApiV1ExamRevisionLangBotexamlangidTranslationQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ExamRevisionLangBotexamlangidTranslationQueryKey,
>(
  botExamLangId: GetApiV1ExamRevisionLangBotexamlangidTranslationPathParams["botExamLangId"],
  params?: GetApiV1ExamRevisionLangBotexamlangidTranslationQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamRevisionLangBotexamlangidTranslationQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamRevisionLangBotexamlangidTranslation401
          | GetApiV1ExamRevisionLangBotexamlangidTranslation404
          | GetApiV1ExamRevisionLangBotexamlangidTranslation500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamRevisionLangBotexamlangidTranslationQueryKey(
      botExamLangId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1ExamRevisionLangBotexamlangidTranslationQueryOptions(
        botExamLangId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionLangBotexamlangidTranslation401
      | GetApiV1ExamRevisionLangBotexamlangidTranslation404
      | GetApiV1ExamRevisionLangBotexamlangidTranslation500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
